import { render, staticRenderFns } from "./newestNotic.vue?vue&type=template&id=71d15224&scoped=true"
import script from "./newestNotic.vue?vue&type=script&lang=js"
export * from "./newestNotic.vue?vue&type=script&lang=js"
import style0 from "./newestNotic.vue?vue&type=style&index=0&id=71d15224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d15224",
  null
  
)

export default component.exports